'use strict';

var mapAPI = require('../../components/googleMapsLocation');
var errorMessage = $('#errormessage').val();

var toastMessageHelper = require('../../utils/toastMessageHelper');
var validateUtils = require('../../utils/dataAndSlots');

$(document).on('click', '#storepickPageContainer .pickup-type-switch label', function () {
    $('#storepickPageContainer .pickup-type-switch label').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '#storepickPageContainer .storedata .store-container', function () {
    $('#storepickPageContainer .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
    var $dateInput = $('#ckc-pickup-appointment-date');
    if ($dateInput.length && $dateInput.data('datepicker')) {
        $dateInput.datepicker('setDate', null);
        $dateInput.val('');
    }
    $('#pickupSlots .session-time-slots li').removeClass('active');
    $('.pick-selected-value').each(function () {
        var altText = $(this).data('alttext');
        $(this).text(altText || '').removeClass('timeslot-selected-value');
    });
});

/**
 * Clean a value for form inputs by removing commas and trimming whitespace.
 *
 * @param {any} v - value to clean (string/number/null/undefined)
 * @returns {string} cleaned string ('' if input falsy)
 */
function clean(v) {
    return v ? String(v).replace(/,/g, '').trim() : '';
}

/**
 * Fills the address fields in the appointment or update address forms
 * based on the selected location stored in #selectedLocation input.
 *
 * Expected structure of selectedLocation value:
 * {
 *   address1: "string",
 *   address2: "string",
 *   pincode: "string",
 *   city: "string"
 * }
 *
 * The function updates both:
 * 1. `.storepick-updateaddress-page` form (if visible)
 * 2. `.storepick-appointment-form` form (if visible)
 *
 * It also removes 'is-invalid' classes and clears any validation messages.
 *
 * @returns {void}
 */
function fillAddress() {
    try {
        const locationVal = $('#selectedLocation').val();
        if (!locationVal) return;

        const location = JSON.parse(locationVal);
        if (!location || typeof location !== 'object') return;

        const address1 = clean(location.address1);
        const address2 = clean(location.address2);
        const pincode = clean(location.pincode);
        const city = clean(location.city);

        const updatePage = $('.storepick-updateaddress-page');
        const appointmentPage = $('.storepick-appointment-form');

        // -----------------------------
        // UPDATE: storepick-updateaddress-page
        // -----------------------------
        if (updatePage.length && !updatePage.hasClass('d-none')) {
            updatePage.find('#updateaddress1').val(address1).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            updatePage.find('#updateaddress2').val(address2).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            updatePage.find('#updatedpostalCode').val(pincode).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            updatePage.find('#updatedcity').val(city).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
        }

        // -----------------------------
        // UPDATE: storepick-appointment-form
        // -----------------------------
        if (appointmentPage.length && !appointmentPage.hasClass('d-none')) {
            appointmentPage.find('#Address1').val(address1).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            appointmentPage.find('#Address2').val(address2).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            appointmentPage.find('#pincode').val(pincode).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
            appointmentPage.find('#city').val(city).removeClass('is-invalid').siblings('.invalid-feedback')
                .text('');
        }
    } catch (error) {
        // toastMessageHelper.showNotification('Error in fillAddress:', 'Error');
    }
}

/**
 * Loads available pickup slots for a given store via AJAX and updates the DOM.
 *
 * Sends a GET request to the 'TryAtShowRoom-GetSlots' endpoint with the store ID.
 * On success:
 *   1. Replaces the HTML content of #pickupSlots with the returned HTML.
 *   2. Iterates over all elements with class `.pick-selected-value` and sets
 *      their text to the value of their `data-alttext` attribute (or empty string).
 *
 * @param {string|number} storeId - The ID of the store to fetch pickup slots for.
 * @returns {void}
 */
function loadSlots(storeId) {
    $.ajax({
        url: 'TryAtShowRoom-GetSlots',
        method: 'GET',
        data: {
            storeID: storeId
        },
        success: function (html) {
            $('#pickupSlots').html(html);
            $('.pick-selected-value').each(function () {
                var $this = $(this);
                var altText = $this.data('alttext');
                $this.text(altText || '');
            });
        }
    });
}

$(document).on('change', '.storedata input[name="storeOption"]', function () {
    var storeId = $(this).val();
    loadSlots(storeId);
});

$('body').on('changeDate', '#ckc-pickup-appointment-date, #ckc-earpiercing-appointment-date', function () {
    let selectedDate = $(this).datepicker('getFormattedDate');
    $(this).val(selectedDate);
    $(this).datepicker('hide');
});

$(document).on('click', '.pickup-ride-button', function (e) {
    e.preventDefault();

    var rideOption = $('input[name="rideOption"]:checked').val() || '';
    var $selectedContainer = $('#storepickPageContainer .storedata .store-container.checked');
    var $selectedStore = $selectedContainer.find('input[name="storeOption"]');
    var storeID = $selectedStore.val() || '';
    var storeName = $selectedContainer.find('.store-name').text().trim();
    var storeAddress = $selectedContainer.find('.store-address').text().trim();
    var pickupDate = $('#ckc-pickup-appointment-date').val().trim();
    var pickupTime = $('#pickupSlots .session-time-slots li.active').text().trim() || $('.pick-selected-value').text().trim();
    var formurl = $('#formurl').val();
    $('#rideoptionselected').val(rideOption);
    $('#storename').val(storeName);
    $('#storeid').val(storeID);
    $('#selectdate').val(pickupDate);
    $('#selecttime').val(pickupTime);
    $('#storeaddress').val(storeAddress);

    var isValid = true;

    if (rideOption === '') {
        $('.ridepickup').removeClass('d-none');
        isValid = false;
    }

    if (pickupDate === '') {
        $('.select-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (pickupTime === 'select your slot') {
        $('.pickup-slots').removeClass('d-none');
        $('.noslots-available').addClass('d-none');
        isValid = false;
    }

    var $datePickerWrapper = $('.date-picker-input');
    var $slotdiv = $('#slot-dropdown-section');
    var $dateError = $('.select-date-picker');
    var $slotError = $('.pickup-slots');
    if (!$slotError.hasClass('d-none')) {
        $slotdiv.addClass('is-invalid');
    } else {
        $slotdiv.removeClass('is-invalid');
    }

    if (!$dateError.hasClass('d-none')) {
        $datePickerWrapper.addClass('is-invalid');
    } else {
        $datePickerWrapper.removeClass('is-invalid');
    }

    if (!isValid) return;
    $.spinner().start();
    if (isValid) {
        $.ajax({
            url: formurl,
            method: 'GET',
            data: {
                rideoptionselected: rideOption
            },
            success: function (html) {
                $.spinner().stop();
                var $appointmentFormContainer = $('#pickup-appointment-form');
                if ($appointmentFormContainer.length) {
                    $appointmentFormContainer.html(html);
                }
                $('.storepick-page-container').addClass('d-none');
                $('#pickup-appointment-form').removeClass('d-none');
                $('html, body').animate({
                    scrollTop: $appointmentFormContainer.offset().top
                }, 500);
                $appointmentFormContainer.scrollTop(0);
                // Initialize mapAPI after form is loaded
                mapAPI.initMap();
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification(errorMessage);
            }
        });
    }
});

$(document).on('change', 'input[name="rideOption"]', function () {
    $('.ridepickup').addClass('d-none');
});

/**
 * Fetches and updates available pickup appointment time slots based on selected date and store.
 *
 * Collects selected store ID, customer contact details, selected pickup date,
 * and previously selected time slot, then sends an AJAX POST request to retrieve
 * updated pickup slot HTML content. On success, it replaces the pickup slot container content.
 *
 * @function updatePickupSlots
 * @returns {void}
 */
function updatePickupSlots() {
    var selectedDate = $('#ckc-pickup-appointment-date').val();
    var storeID = $('#storepickPageContainer .storedata .store-container.checked input[type="radio"]').val();
    var url = $('#picktimeslots').data('url');
    var selectedslot = $('.pick-selected-value').attr('data-slot');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot || ''
    };

    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#pickupSlots').html('');
            if (data.success === false) {
                return;
            }
            $('#pickupSlots').html(data);
        }
    });
}

$(document).on('change', '#ckc-pickup-appointment-date', function () {
    $('.select-date-picker').addClass('d-none');
    $('.date-picker-input').removeClass('is-invalid');
    var $tasSelectedValue = $('.pick-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.removeClass('timeslot-selected-value');
        $('.session-time-slots .time-slot-value').removeClass('time-slot-value-highlight');
        $tasSelectedValue.attr('data-slot', '');
    }

    updatePickupSlots();
});

$(document).on('click', '.session-time-slots li', function () {
    $('.pickup-slots').addClass('d-none');
    $('#slot-dropdown-section').removeClass('is-invalid');
    $('.invalid-feedback .noslots-available').addClass('d-none');
});

$(document).on('click', '.confirmation-buttons .checkbox-checked', function (e) {
    e.preventDefault();
    $(this).toggleClass('checked');
});

$('body').on('click', '.form-check-option', function () {
    $(`#${$(this).attr('for')}`).click();
});

/**
 * Handle go-back button click to return to store pickup page
 */
$(document).on('click', '.go-back', function (e) {
    e.preventDefault();
    $('#pickup-appointment-form').addClass('d-none');
    $('#storepickPageContainer').removeClass('d-none');
    // scroll the page so that the form container is visible
    $('html, body').animate({
        scrollTop: $('#storepickPageContainer').offset().top
    }, 500);
    $('#storepickPageContainer').scrollTop(0);
});

/**
 * Validates a guest checkout field using contextual rules (name, email, phone, or generic required checks).
 * @param {JQuery} $field - The input/select element wrapped in jQuery whose value should be validated.
 * @returns {boolean} True when the field value complies with its rules; otherwise false with feedback applied.
 */
function validateField($field) {
    var value = $field.val();
    var isValid = true;
    var errorMsg = '';
    var $errorDiv;
    var fieldId = $field.attr('id');
    var isNameField = fieldId === 'firstName' || fieldId === 'lastName';
    var isEmailField = $field.attr('type') === 'email';
    var isPhoneField = $field.attr('type') === 'tel' || fieldId === 'phone';
    var isPostalCodeField = fieldId === 'pincode' || fieldId === 'updatedpostalCode';
    var isCityField = fieldId === 'city' || fieldId === 'updatedcity';
    var isAddressField = fieldId === 'Address1' || fieldId === 'Address2' || fieldId === 'updateaddress1' || fieldId === 'updateaddress2';

    if ($field.attr('type') === 'checkbox') {
        if ($field.attr('id') === 'termsAccepted') {
            $errorDiv = $field.closest('.form-check').find('.invalid-feedback');

            if (!$field.is(':checked')) {
                $field.addClass('is-invalid');
                $errorDiv.text($field.data('missing-error')).show();
                return false;
            }
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
            return true;
        }
        return true;
    }

    if (isNameField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var pattern = /^[A-Za-z][A-Za-z\s]*$/;
        if (isValid && value && !pattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('invalid-error');
        }
    } else if (isEmailField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9@._-]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var emailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (isValid && value && !emailPattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('pattern-mismatch') || 'Please enter a valid email address';
        }
    } else if (isPhoneField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue;

        const isRequired = $field.prop('required')
            || $field.closest('.form-group').hasClass('required');

        const requiredLength = parseInt($field.attr('data-phonelength'), 10)
            || parseInt($field.attr('maxlength'), 10)
            || 10;

        if (isRequired && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        if (value.length === 1 && !/^[6-9]$/.test(value)) {
            $field.val('');
            value = '';
        }

        if (isValid && value.length > 0 && value.length !== requiredLength) {
            isValid = false;
            errorMsg = `Enter valid ${requiredLength}-digit phone number`;
        }
    } else if (isPostalCodeField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue.length > 6) cleanedValue = cleanedValue.substring(0, 6);
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Postal code is required';
        } else if (value && value.length !== 6) {
            isValid = false;
            errorMsg = 'Postal code must be 6 digits';
        }
    } else if (isCityField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'City is required';
        }
    } else if (isAddressField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9\s,.\-/]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Address is required';
        }
    } else {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    }

    $errorDiv = $field.siblings('.invalid-feedback');

    if (!isValid) {
        $field.addClass('is-invalid');
        $errorDiv.text(errorMsg);
    } else {
        $field.removeClass('is-invalid');
        $errorDiv.text('').hide();
    }

    return isValid;
}

$('body').on('change input blur', '#pickup-appointment-forms input', function () {
    validateField($(this));
});

/**
 * Submits appointment form data via AJAX
 * @param {Object} formData - Form data to submit
 */
function submitAppointmentForm(formData) {
    var url = $('#savedataurl').val();
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: formData,
        success: function (response) {
            $.spinner().stop();
            if (response.success) {
                $('#pickup-appointment-form').addClass('d-none');
                $('#storepick-address-page').removeClass('d-none');
                $('#appointmentID').val(response.appointmentID);
                mapAPI.initMap();
                $.ajax({
                    url: response.secondUrl,
                    method: 'GET',
                    data: {
                        appointmentID: response.appointmentID,
                        rideoptionSelected: response.rideoptionSelected || ''
                    },
                    success: function (secondResponse) {
                        var $appointmentFormContainer = $('#storepick-address-page');
                        $appointmentFormContainer.html(secondResponse);
                        $('html, body').animate({
                            scrollTop: $appointmentFormContainer.offset().top
                        }, 500);
                    },
                    error: function () {
                        toastMessageHelper.showNotification('somwenthing went wrong', 'Failed to load confirmation page');
                    }
                });
            } else {
                var errorMsg = response.message || 'Failed to save appointment. Please try again.';
                toastMessageHelper.showNotification(errorMsg, 'Error');
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification('An error occurred while submitting the form. Please try again', 'Error');
        }
    });
}

/**
 * Displays the pickup appointment form for editing.
 *
 * This function hides the store pickup address section and shows the
 * pickup appointment form. It also scrolls the page to the form and
 * resets the form's scroll position to the top.
 *
 * @function showPickupFormForEdit
 * @returns {void}
 */
function showPickupFormForEdit() {
    $.spinner().start();
    $('#storepick-address-page').addClass('d-none');
    $('#pickup-appointment-form').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#pickup-appointment-form').offset().top
    }, 500);
    $('#pickup-appointment-form').scrollTop(0);
    $.spinner().stop();
}

/**
 * Fetches the user's current location using map API
 * and updates the selected address field.
 *
 * @returns {void}
 */
function fetchCurrentLocationFromMapAPI() {
    mapAPI.getCurrentLocationWithAddress()
        .then(({ address }) => {
            $('#selectedLocation').val(JSON.stringify(address));
            fillAddress();
            $('#locateOnMapModal').modal('hide');
            $.spinner().stop();
        })
        .catch(() => {
            $.spinner().stop();
            if (!$('.location-permission-error').hasClass('opened-once') && $('#tryAtHomeModal').hasClass('enabled')) {
                $('.location-permission-error').removeClass('d-none');
            }
        });
}

/**
 * Handles appointment form submission with validation
 */
$('body').on('click', '.appointment-btn', function (e) {
    e.preventDefault();
    var $form = $('#pickup-appointment-forms');
    var isFormValid = true;
    var appointmentID = $('#appointmentID').val();

    $('#pickup-appointment-forms').find('input').each(function () {
        if (!validateField($(this))) {
            isFormValid = false;
        }
    });

    if (isFormValid) {
        var formData = {
            firstName: $form.find('#firstName').val().trim(),
            lastName: $form.find('#lastName').val().trim(),
            email: $form.find('#email').val().trim(),
            phone: $form.find('#phone').val().trim(),
            address1: $form.find('#Address1').val().trim(),
            address2: $form.find('#Address2').val().trim(),
            pincode: $form.find('#pincode').val().trim(),
            city: $form.find('#city').val().trim(),
            whatsappOption: $form.find('#whatsappoption').is(':checked'),
            textmessage: $form.find('#textoption').is(':checked'),
            emailOption: $form.find('label[for="emailoption"]').hasClass('checked'),
            rideoptionselected: $('#rideoptionselected').val().trim(),
            storeName: $('#storename').val().trim(),
            storeID: $('#storeid').val().trim(),
            appointmentID: appointmentID,
            selecttime: $('#selecttime').val().trim(),
            selectdate: $('#selectdate').val().trim(),
            salutation: $('#catalogueTitle').val().trim(),
            termandcontitions: $('#termsAccepted').is(':checked'),
            countrycode: $('.country-code-text').text().trim(),
            pickupconfirmation: $('#pickupconfirmation').is(':checked')
        };

        submitAppointmentForm(formData);
    } else {
        var $firstError = $form.find('.is-invalid').first();
        if ($firstError.length) {
            $firstError[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }
});

$('body').on('click', '.our-location-btn', function (e) {
    e.preventDefault();
    $('#locateOnMapModal').modal('show');
});

$('body').on('click', '.btn-cancel-location', function () {
    $('#selectedLocation').val('');
    $('#locateOnMapModal').modal('hide');
});

$('body').on('click', '.btn-confirm-location', function () {
    mapAPI.updateLatLng($('#selectedLocation'));
    $('#locateOnMapModal').modal('hide');
    fillAddress();
});

$('body').on('click', '.btnCurrentLocation', function (e) {
    e.preventDefault();
    $.spinner().start();
    if (navigator.permissions) {
        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
            if (result.state === 'denied') {
                $.spinner().stop();

                // eslint-disable-next-line no-alert
                alert('Location access is denied. Please enable it in your browser settings.');
            } else {
                fetchCurrentLocationFromMapAPI();
            }
        });
    } else {
        fetchCurrentLocationFromMapAPI();
    }
});

$('.location-permission-error, .location-permission-close').on('click', function () {
    $('.location-permission-error').addClass('d-none').addClass('opened-once');
});

$(document).on('change', '#pickupconfirmation', function () {
    if (!$(this).is(':checked')) {
        $('#upadate-adddress').trigger('click');
    }
});

/**
 * Handle update address button click
 */
$(document).on('click', '#upadate-adddress', function (e) {
    e.preventDefault();
    $('#pickupconfirmation').prop('checked', false);

    var updateAddressURL = $('#updateurl').val();
    $.spinner().start();
    $.ajax({
        url: updateAddressURL,
        method: 'GET',
        success: function (html) {
            $.spinner().stop();
            var $addresupdatedFormContainer = $('#storepick-updateaddress-page');
            $('#pickup-appointment-form').addClass('d-none');
            $addresupdatedFormContainer.removeClass('d-none');
            if ($addresupdatedFormContainer.length === 1) {
                $addresupdatedFormContainer.html(html);
            }
            $('html, body').animate({
                scrollTop: $addresupdatedFormContainer.offset().top
            }, 500);
            mapAPI.initMap();
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification('Failed to load edit address form', 'Error');
        }
    });
});

/**
 * Handle cancel button in edit address form
 */
$(document).on('click', '#storepick-updateaddress-page .cancel-address-btn', function (e) {
    e.preventDefault();
    $('#storepick-updateaddress-page').addClass('d-none');
    $('#pickup-appointment-form').removeClass('d-none');
});

/**
 * Handle save button in edit address form
 */
$(document).on('click', '#storepick-updateaddress-page .update-address-btn', function (e) {
    e.preventDefault();

    var savetheupdatedaddress = $('#savetheupdatedaddress').val();
    var isFormValid = true;
    $('#updateaddres-form-inputs').find('input').each(function () {
        if (!validateField($(this))) {
            isFormValid = false;
        }
    });
    if (isFormValid) {
        var formData = {
            upadateaddress1: $('#updateaddress1').val().trim(),
            upadateaddress2: $('#updateaddress2').val().trim(),
            upadatepincode: $('#updatedpostalCode').val().trim(),
            upadatecity: $('#updatedcity').val().trim()
        };
        $.spinner().start();
        $.ajax({
            url: savetheupdatedaddress,
            method: 'POST',
            data: formData,
            success: function (response) {
                $.spinner().stop();
                if (response.success) {
                    $('#storepick-updateaddress-page').addClass('d-none');
                    $('#pickup-appointment-form').removeClass('d-none');
                    toastMessageHelper.showNotification('Success', 'Address updated successfully');
                    $('.updateaddress').find('#upadate-adddress').addClass('d-none');
                    $('#appointmentID').val(response.appointmentID);
                } else {
                    toastMessageHelper.showNotification(errorMessage);
                }
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification('Error', 'An error occurred while updating the address');
            }
        });
    }
});

$('body').on('change input blur', '#updateaddres-form-inputs input', function () {
    validateField($(this));
});

/**
 * Handle pickup-editbtn click to enable address editing
 */
$(document).on('click', '#pickupeditbtn', function (e) {
    e.preventDefault();

    var $pickupInput = $('#storepick-address-page #Address1');
    var $dropInput = $('#storepick-address-page #Address2');

    $pickupInput.prop('readonly', false);
    $dropInput.prop('readonly', false);

    $('.default-buttons').addClass('d-none');
    $('.edit-buttons').removeClass('d-none');

    toastMessageHelper.showNotification('Update Now', 'You can now edit the addresses');
});

/**
 * Handle cancel button click in edit mode
 */
$(document).on('click', '.cancel-edit-btn', function (e) {
    e.preventDefault();

    var $pickupInput = $('#storepick-address-page #Address1');
    var $dropInput = $('#storepick-address-page #Address2');

    var originalPickupValue = $pickupInput.data('original-value') || '';
    var originalDropValue = $dropInput.data('original-value') || '';

    $pickupInput.val(originalPickupValue);
    $dropInput.val(originalDropValue);

    $pickupInput.prop('readonly', true);
    $dropInput.prop('readonly', true);

    $('.edit-buttons').addClass('d-none');
    $('.default-buttons').removeClass('d-none');

    toastMessageHelper.showNotification('Cancelled', 'Changes have been cancelled');
});

/**
 * Handle save button click in edit mode
 */
$(document).on('click', '.save-edit-btn', function (e) {
    e.preventDefault();

    var saveAddressUrl = $('#saveAddressUrl').val();
    var appointmentID = $('#appointmentID').val();
    var pickupAddress = $('#storepick-address-page #Address1').val();
    var dropAddress = $('#storepick-address-page #Address2').val();

    $.spinner().start();
    $.ajax({
        url: saveAddressUrl,
        method: 'POST',
        data: {
            appointmentID: appointmentID,
            pickupAddress: pickupAddress,
            dropAddress: dropAddress
        },
        success: function (response) {
            $.spinner().stop();
            if (response.success) {
                var $pickupInput = $('#storepick-address-page #Address1');
                var $dropInput = $('#storepick-address-page #Address2');

                $pickupInput.prop('readonly', true);
                $dropInput.prop('readonly', true);

                $('.edit-buttons').addClass('d-none');
                $('.default-buttons').removeClass('d-none');
                toastMessageHelper.showNotification('Successfully Updated', 'Data updated successfully');
            } else {
                toastMessageHelper.showNotification('Error', response.message || 'Failed to save addresses');
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification('Error', 'An error occurred while saving');
        }
    });
});

/**
 * Handle proceed button click to show confirmation page
 */
$(document).on('click', '.comfirm-ride-proceed', function (e) {
    e.preventDefault();

    var successPageUrl = $('#successPageUrl').val();
    var appointmentID = $('#appointmentID').val();
    var pickupDate = $('#selectdate').val();
    var pickupTime = $('#selecttime').val();
    var storeAddress = $('#storeaddress').val();
    $.spinner().start();
    $.ajax({
        url: successPageUrl,
        method: 'GET',
        data: {
            appointmentID: appointmentID,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            storeAddress: storeAddress
        },
        success: function (html) {
            $.spinner().stop();
            $('#storepick-address-page').addClass('d-none');
            $('.pd-hero-banner, .service-image-banner, .astralcomponent-container, .testimonial-section').addClass('d-none');
            $('.storepage .service-image-banner:last').removeClass('d-none');
            $('.divider-image.text-center').removeClass('d-none');
            $('#storepick-confirmation-page').append(html);
            $('#storepick-confirmation-page').removeClass('d-none');
            $('html, body').animate({
                scrollTop: $('#storepick-confirmation-page').offset().top
            }, 500);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification('Failed to load confirmation page');
        }
    });
});

$(document).on('click', '.pickup-appointment-cancel-book-btn', function (e) {
    e.preventDefault();
    showPickupFormForEdit();
});

$(document).on('click', '.vintage-car-cancel-book-btn', function (e) {
    e.preventDefault();
    var cancelUrl = $('#cancelBookingUrl').val();

    if (!cancelUrl) {
        window.location.reload();
    }
});

$('body').on('click', '#slot-dropdown-section', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }
    var selectedDate = $('#ckc-pickup-appointment-date').val();
    if (!selectedDate) {
        return;
    }
    var storeID = $('#storepickPageContainer .storedata .store-container.checked input[type="radio"]').val();
    var url = $('#picktimeslots').data('url');
    var selectedslot = $('.pick-selected-value').attr('data-slot');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#pickupSlots').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.pickup-slots, .pickup-slot-scroll.scroll-bar').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('.pickup-slot-scroll.scroll-bar').removeClass('d-none');
            $('#pickupSlots').html(data);
            $('.pickup-slot-scroll').scrollTop(0);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#pickupSlots .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;

    var selectedSlot = $(this).data('id');
    $('#picktimeslots').val(selectedSlot);

    $('.pick-selected-value').attr('data-slot', selectedSlot);
});

$('body').on('click', '#storepickPageContainer .time-slot-session .time-slot-value', function () {
    var $this = $(this);
    var $selected = $this.closest('.time-slot-select').find('.custom-drop-down-section .selected-value');
    $selected.addClass('timeslot-selected-value');
});

$('body').on('click', '.form-firstname-dropdown .custom-option-value', function () {
    var $this = $(this);
    var titleCode = $this.data('title');
    var titleText = $this.text().trim();
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    $this.closest('.custom-drop-down-section').find('.selected-value').text(titleText);
    $('#catalogueTitle').val(titleCode);
});

$('body').on('click', '.condition-check, #read-terms, .terms-condition', function (e) {
    e.preventDefault();
    var $checkbox = $('#termsAccepted');
    if ($checkbox.is(':checked')) {
        $checkbox.prop('checked', false);
    } else {
        $('#terms-and-conditions-appointment-modal').modal('show');
    }
});

$('body').on('click', '#appointmentagree-btn', function () {
    $('#terms-and-conditions-appointment-modal').modal('hide');
    $('#termsAccepted').prop('checked', true);
    validateField($('#termsAccepted'));
});

$('body').on('click', '.cancel-address-btn', function () {
    $('#pickupconfirmation').prop('checked', true);
});

$('body').on('click', '#ckc-pickup-appointment-date, .pickup-icon', function (e) {
    e.preventDefault();
    var $dateInput = $('#ckc-pickup-appointment-date');
    if (!$dateInput.data('datepicker')) {
        validateUtils.initializeEarPiercingDatepicker();
    }
    $dateInput.datepicker('show');
});

$('body').on('click', '#pickupedit-btn', function (e) {
    e.preventDefault();
    showPickupFormForEdit();
});

$('body').on('change input blur', '#ckc-pickup-appointment-date', function () {
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var selectedDate = $(this).val();
    var $slotdropdown = $('#slot-dropdown-section .slot-dropdown');
    var $slotdiv = $('.time-slot-select .custom-drop-down-section');
    if (selectedDate) {
        $slotdropdown.removeClass('disabledstate');
        $slotdiv.removeClass('slot-dropdown-section');
    } else {
        $slotdropdown.addClass('disabledstate');
        $slotdiv.addClass('slot-dropdown-section');
    }
});
